import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import omitBy from 'lodash/omitBy';
import compact from 'lodash/compact';

function getData(database) {
  return database.data;
}

function mergeData(database, dataFn) {
  var data;
  var previousData = getData(database);

  if (typeof dataFn === 'function') {
    data = dataFn(previousData);
  } else {
    data = _objectSpread({}, previousData, {}, dataFn);
  }

  return database.setData(data);
}

function getFrozenOrder(database) {
  var _getData = getData(database),
      frozenOrder = _getData.frozenOrder;

  return frozenOrder;
}

function setFrozenOrder(database, updateFn) {
  var activeSort = database.getActiveSort();

  var _getData2 = getData(database),
      frozenOrder = _getData2.frozenOrder;

  if (frozenOrder && !updateFn || !activeSort) return;
  var recordsOrder = database.getSortedRecords().map(function (_ref) {
    var key = _ref.key;
    return key;
  });

  var modifierFn = updateFn || function (x) {
    return x;
  };

  mergeData(database, {
    frozenOrder: modifierFn(recordsOrder)
  });
}

function removeFrozenOrder(database) {
  var _getData3 = getData(database),
      frozenOrder = _getData3.frozenOrder;

  if (!frozenOrder) return;
  mergeData(database, {
    frozenOrder: null
  });
}

function getOrderedRecords(database, records) {
  var frozenOrder = getFrozenOrder(database);
  var frozenRecords = compact(frozenOrder.map(function (key) {
    return records[key];
  }));
  var newRecords = Object.values(omitBy(records, function (value, key) {
    return frozenOrder.includes(key);
  })).sort(function (a, b) {
    return a.createdAt - b.createdAt;
  });
  return [].concat(_toConsumableArray(frozenRecords), _toConsumableArray(newRecords));
}

export default {
  commands: {
    setFrozenOrder: setFrozenOrder,
    removeFrozenOrder: removeFrozenOrder
  },
  queries: {
    getFrozenOrder: getFrozenOrder,
    getOrderedRecords: getOrderedRecords
  }
};